import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface InitiateCallRequest {
  to_number: string;
  from_number?: string;
  check_in_id?: string;
  task_id?: string;
}

export interface InitiateCallResponse {
  call_id: string;
  status: string;
  message?: string;
}

export const dialpadApi = createApi({
  reducerPath: 'dialpadApi',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    initiateCall: builder.mutation<
      InitiateCallResponse,
      { matterId: string } & InitiateCallRequest
    >({
      query: ({ matterId, ...body }) => ({
        url: `api/matters/${matterId}/dialpad/initiate_call/`,
        method: 'POST',
        body,
      }),
    }),

    getDialpadCallArtifact: builder.query<
      {
        call_id: string;
        conversation_id?: string | null;
        dialpad_call_pk?: string | null;
        dialpad_user_name?: string | null;
        artifact_id?: string | null;
        matter_id?: string | null;
      },
      { callId: string; fromNumber?: string }
    >({
      query: ({ callId, fromNumber }) => ({
        url: `api/integrations/dialpad/call/${encodeURIComponent(callId)}/artifact/${fromNumber ? `?from_number=${encodeURIComponent(fromNumber)}` : ''}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useInitiateCallMutation,
  useGetDialpadCallArtifactQuery,
  useLazyGetDialpadCallArtifactQuery,
} = dialpadApi;
